import React, { HTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';

type HeadingProps = {
    level?: 1 | 2 | 3 | 4 | 5 | 6;
} & HTMLAttributes<HTMLHeadingElement>;

export const Heading = ({level = 1, className, children}: HeadingProps) => {
    return React.createElement(`h${level}`, {
        className: twMerge(
            'text-on-background',
            level === 1 && 'my-4 text-3xl font-black',
            level === 2 && 'my-3 text-2xl font-bold ',
            level === 3 && 'my-2 text-xl font-semibold',
            level === 4 && 'my-1 text-lg font-semibold',
            level === 5 && 'my-1 text-md font-medium',
            level === 6 && 'my-1 font-medium',
            className
        ),
        children
    });
}
